import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import global_en from "./locals/langs/en.json";
import global_es from "./locals/langs/es.json";
import global_ar from "./locals/langs/ar.json";
import global_de from "./locals/langs/de.json";
import global_fr from "./locals/langs/fr.json";
import global_ja from "./locals/langs/ja.json";
import global_pt from "./locals/langs/pt.json";
import global_ru from "./locals/langs/ru.json";
import global_vi from "./locals/langs/vi.json";
import global_zh from "./locals/langs/zh.json";
import global_hi from "./locals/langs/hi.json";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "English",
  resources: {
    English: {
      global: global_en,
    },
    Spanish: {
      global: global_es,
    },
    Arabic: {
      global: global_ar,
    },
    German: {
      global: global_de,
    },
    French: {
      global: global_fr,
    },
    Japanese: {
      global: global_ja,
    },
    Portuguese: {
      global: global_pt,
    },
    Russian: {
      global: global_ru,
    },
    Vietnamese: {
      global: global_vi,
    },
    Chinese: {
      global: global_zh,
    },
    Hindi: {
      global: global_hi,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
